// extracted by css-extract-rspack-plugin
export default {"field":"xDvLqtLWmHI1ZfP9","input":"pZu1W33edkYoBFHd","spacerSegment":"ekuuRLBKz8wCrUtm","segment":"teoel9e73owSyHCm"};